import { Button } from '@slal/ui/buttons';
import { AccordionSection } from '@slal/ui/display';
import { Article, Heading, P, Ul } from '@slal/ui/typography';
import { MaxWidthContent, Notification } from '~/components';
import { useAnalytics } from '~/hooks';
import { ListItem, StyledAccordion, StyledActionLink, StyledEstimatedTimelines, StyledNextStepsCard } from './styles';

export const CREATE_APPLICATION_RESPONSE = 'CREATE_APPLICATION_RESPONSE';

const nextStepsId = 'next-steps-list';

const EstimatedTimescales = ({ estimatedTimescale, ...otherProps }: { estimatedTimescale: string }) => (
    <StyledEstimatedTimelines
        items={[{ label: 'Estimated payment date:', value: estimatedTimescale }]}
        {...otherProps}
    />
);

const NextSteps = ({ nextSteps, ...otherProps }: { nextSteps: Array<string> }) => {
    return (
        <Ul {...otherProps}>
            {nextSteps.map((step, index) => (
                <ListItem key={index}>{step}</ListItem>
            ))}
        </Ul>
    );
};

const ChangeMyMind = () => {
    return (
        <StyledAccordion>
            <AccordionSection id="change-my-mind-information" title="Can I change my mind?">
                <Article>
                    <P>You have 30 days to cancel after you receive your plan documents.</P>
                    <P>
                        After this, you'll be bound by the terms and conditions of the plan and any money received by
                        Standard Life will not be refundable under the cancellation rule.
                    </P>
                    <P>
                        Before we can return any plan transferred in, you must speak with ReAssure to get their
                        agreement to accept the pension back. If you have taken tax-free cash, you don’t have a right to
                        change your mind and cancel this payment. We cannot accept the return of any tax-free cash
                        payments. Should this not be possible, you must arrange for another pension provider to accept
                        the transfer instead.
                    </P>
                </Article>
            </AccordionSection>
        </StyledAccordion>
    );
};

export const Confirmation = () => {
    const { pushEvent } = useAnalytics();
    const createApplicationResponse = JSON.parse(sessionStorage.getItem(CREATE_APPLICATION_RESPONSE)!);
    const leaveFeedbackLabel = 'Leave feedback';

    return (
        <MaxWidthContent>
            <Notification level="success" heading="Application submitted">
                <P>You'll get a confirmation email in the next 5 minutes.</P>
                {createApplicationResponse?.estimatedTimescales && (
                    <EstimatedTimescales
                        aria-label="Estimated payment date"
                        estimatedTimescale={createApplicationResponse?.estimatedTimescales}
                    />
                )}
            </Notification>
            {!!createApplicationResponse?.nextSteps?.length && (
                <StyledNextStepsCard>
                    <Article>
                        <Heading id={nextStepsId} level={2}>
                            What happens next
                        </Heading>
                        <NextSteps aria-labelledBy={nextStepsId} nextSteps={createApplicationResponse?.nextSteps} />
                    </Article>
                    <ChangeMyMind />
                    <StyledActionLink
                        href="https://www.standardlife.co.uk/feedback/reassure"
                        target="_blank"
                        onClick={() => pushEvent({ eventLabel: `${leaveFeedbackLabel} button click` })}
                    >
                        <Button color="secondary" fullWidth>
                            {leaveFeedbackLabel}
                        </Button>
                    </StyledActionLink>
                </StyledNextStepsCard>
            )}
        </MaxWidthContent>
    );
};
